module.exports = __webpack_public_path__ + "static/youtube-2bd2c7d9e1e9bf6200480e9b2b4c304f.png";